var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('b-col',{staticClass:"mx-0 px-0 my-0 py-0",attrs:{"sm":_vm.labelSize}},[_c('label',[_vm._v(_vm._s(_vm.showTheLabel))])]),_c('b-col',{staticClass:"mx-0 px-0 my-0 py-0",attrs:{"sm":_vm.objectSize}},[_vm._v(_vm._s(_vm.showTheObject)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }